var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_93_28)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 26.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2545 40.75L19.7755 35.161C18.7733 33.443 18.2467 31.489 18.25 29.5C18.25 23.2866 23.2866 18.25 29.5 18.25C35.7134 18.25 40.75 23.2866 40.75 29.5C40.75 35.7134 35.7134 40.75 29.5 40.75C27.5119 40.7532 25.5588 40.2271 23.8413 39.2256L18.2545 40.75ZM25.4399 24.2215C25.2946 24.2305 25.1526 24.2688 25.0225 24.334C24.9005 24.4031 24.7891 24.4895 24.6918 24.5905C24.5568 24.7176 24.4803 24.8279 24.3981 24.9348C23.9824 25.4759 23.7587 26.1401 23.7625 26.8225C23.7648 27.3737 23.9088 27.9104 24.1338 28.4121C24.5939 29.4269 25.351 30.5012 26.3511 31.4969C26.5919 31.7365 26.827 31.9773 27.0801 32.2011C28.3215 33.294 29.8007 34.0822 31.4001 34.5029L32.0403 34.6007C32.2484 34.612 32.4565 34.5963 32.6658 34.5861C32.9934 34.5692 33.3133 34.4805 33.6029 34.3263C33.7502 34.2504 33.894 34.1678 34.0338 34.0787C34.0338 34.0787 34.0821 34.0472 34.1744 33.9775C34.3263 33.865 34.4196 33.7851 34.5456 33.6535C34.639 33.5568 34.72 33.4431 34.7819 33.3138C34.8696 33.1304 34.9574 32.7805 34.9934 32.4891C35.0204 32.2664 35.0125 32.1449 35.0091 32.0695C35.0046 31.9491 34.9045 31.8243 34.7954 31.7714L34.1406 31.4778C34.1406 31.4778 33.1619 31.0514 32.5645 30.7791C32.5015 30.7517 32.434 30.736 32.3654 30.733C32.2884 30.7251 32.2106 30.7338 32.1373 30.7584C32.0639 30.783 31.9967 30.8231 31.9401 30.8759V30.8736C31.9345 30.8736 31.8591 30.9377 31.0458 31.9233C30.9991 31.986 30.9348 32.0334 30.861 32.0594C30.7873 32.0855 30.7075 32.089 30.6318 32.0695C30.5585 32.0499 30.4867 32.0251 30.4169 31.9953C30.2774 31.9368 30.229 31.9143 30.1334 31.8726L30.1278 31.8704C29.4842 31.5894 28.8883 31.2098 28.3615 30.7454C28.2198 30.6216 28.0881 30.4866 27.9531 30.3561C27.5105 29.9323 27.1248 29.4528 26.8056 28.9296L26.7393 28.8228C26.6916 28.7509 26.653 28.6735 26.6245 28.5921C26.5818 28.4268 26.6931 28.294 26.6931 28.294C26.6931 28.294 26.9665 27.9948 27.0936 27.8327C27.1995 27.6981 27.2982 27.558 27.3895 27.4131C27.5223 27.1994 27.5639 26.98 27.4941 26.8101C27.1791 26.0406 26.8529 25.2745 26.5176 24.514C26.4513 24.3632 26.2544 24.2552 26.0755 24.2339C26.0148 24.2271 25.954 24.2204 25.8933 24.2159C25.7422 24.2084 25.5908 24.2099 25.4399 24.2204V24.2215Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_93_28",
    x: 0,
    y: 0,
    width: 67,
    height: 67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_93_28"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_28"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_28",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.1a75f3bcae0c07b82203cc0e364fea9e.svg";
export { ForwardRef as ReactComponent };